module.exports = __webpack_public_path__ + "static/media/dropbox.9a02c7a5.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/Portfolio/images/platforms/dropbox.png
 ** module id = 215
 ** module chunks = 0
 **/